import React from 'react';
import AfricaMap from './AfricaMap';
import { SectorBanner, AddressFooter, MainFooter } from './Footer';

// This wrapper applies the Varahi letterhead template to every page:
// White background, Africa map watermark, sector banner, address footer
const PageWrapper = ({ children, onNavigate, showFullFooter = false }) => (
  <div className="page-template">
    {/* Africa map watermark — exactly as in template image */}
    <AfricaMap className="africa-watermark" />

    {/* Page content sits on top of watermark */}
    <div className="page-content">
      {children}
    </div>

    {/* Sector banner — matches image bottom bar */}
    <SectorBanner />

    {/* Address line — matches image very bottom */}
    {showFullFooter ? (
      <MainFooter onNavigate={onNavigate} />
    ) : (
      <AddressFooter />
    )}
  </div>
);

export default PageWrapper;
